import "./Cursos.module.css";
import Header from "@/reusable_sections/Header";
import UnlockYourFinancialFutureWithOurExpertCourses from "./sections/UnlockYourFinancialFutureWithOurExpertCourses";
import ExploreOurCourseCatalog from "./sections/ExploreOurCourseCatalog";
import Footer from "@/reusable_sections/Footer";
export default function CursosPage() {
  return <div>
      <Header />
      <UnlockYourFinancialFutureWithOurExpertCourses />
      <ExploreOurCourseCatalog />
      <Footer />
    </div>;
}